import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit } from '@angular/core';
import { ScaleRange } from '../../shared/models/scale-range';
import { Scale } from '../../shared/models/scale';

import { AssessmentService } from '../../shared/services/assessment.service';
import { Assessment } from '../../shared/models/assessment';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-scale-range-edit',
  templateUrl: './scale-range-edit.component.html',
  styleUrls: ['./scale-range-edit.component.css']
})
export class ScaleRangeEditComponent implements OnInit {

    private _range:ScaleRange;
  private scale:Scale;
  private assessment:Assessment;
  private readonly SAVE_TIME = 1500;
  private readonly ERROR_MESSAGE_TIME = 3000;
  public isSaving:boolean;

  constructor( private assessmentService:AssessmentService
    ,private alertService: AlertService
    ,private router: Router
    ,private route: ActivatedRoute) { 
      this.range = this.getNewObject();
    }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let scaleId = params['scaleId'];
      let rangeId = params['rangeId'];
      this.assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this.assessment = assessment;
          this.scale = assessment.scales.find((s) => s.id == scaleId);
          this.range = (this.scale) ? this.scale.ranges.find((r) => r.id == rangeId) : null;
          if (!(this.scale && this.range)) {
            // TODO: stephen should we navigate back?? or do some kind of 404?
            this.router.navigate(["not-found"]);
          }
        })
        .catch((error) => {
          console.error(error);
          this.router.navigate(["not-found"]);
        })
    });
  }

  private getNewObject() {
    let obj = new ScaleRange();
    obj.id = this.assessmentService.newId();
    return obj;
  }

  get range():ScaleRange {
    return this._range;
  }

  set range(v:ScaleRange) {
    this._range = v;
  }

  private saveRange(range) {
    this.isSaving = true;
		return this.assessmentService.saveAssessment(this.assessment).then((assessment) => {
      this.alertService.success("Range saved", this.SAVE_TIME);
      this.isSaving = false;
      return range;
    }).catch((error) => {
      this.isSaving = false;
      this.alertService.error("An error occurred in saving. Please try again or contact support.", this.ERROR_MESSAGE_TIME);
			console.error(error);
		});
  }

  save() {
    this.saveRange(this.range);
	}
	
	saveAndCreateNew() {
      this.saveRange(this.range).then((question) => {
        // TODO: stephen for whatever reason this isn't working very well here...
      this.router.navigate(["../../", "new"], {relativeTo: this.route, replaceUrl: true});
      // this.router.navigate(["admin","assessment",this.assessment.uid, "edit"
      //     ,"scale", this.scale.id, "edit"
      //     , "scale-range", "new"], {replaceUrl: true});
    });
	}

}



// WEBPACK FOOTER //
// ./src/app/admin/scale-range-edit/scale-range-edit.component.ts